module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-1@2x__6dcc7934ee771119082223e62766a1f2.png";